const state = {
}

const mutations = {

}


const actions = {

    newARQ({commit, getters, rootState}, payload){
        return new Promise((resolve, reject) => {
            fetch(rootState.restServices.API + '/arq/new', {
                headers: {
                    'Content-Type': 'application/json',
                    'database' : getters.getDatabase
                },
                method: 'POST',
                body: JSON.stringify(payload)
            })
            .then(response => response.json())
            .then(data => {
                resolve(data)
            })
        })
    },


   
}

export default {
    actions,
    mutations,
    state
}